var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1839 1.93733C19.8987 0.387582 22.1013 0.387586 22.8161 1.93733L27.3024 11.6635C27.5937 12.2952 28.1923 12.73 28.883 12.8119L39.5195 14.0731C41.2143 14.274 41.8949 16.3688 40.6419 17.5275L32.7781 24.7998C32.2674 25.272 32.0388 25.9757 32.1744 26.6579L34.2618 37.1636C34.5944 38.8375 32.8125 40.1321 31.3233 39.2985L21.9769 34.0668C21.3699 33.7271 20.6301 33.7271 20.0231 34.0668L10.6767 39.2985C9.1875 40.1321 7.40558 38.8375 7.73819 37.1636L9.82565 26.6579C9.96121 25.9757 9.73257 25.272 9.2219 24.7998L1.35805 17.5275C0.105054 16.3688 0.78569 14.274 2.48048 14.0731L13.117 12.8119C13.8077 12.73 14.4063 12.2952 14.6976 11.6635L19.1839 1.93733Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9c3a0d9d.svg";
export { ForwardRef as ReactComponent };